// localStorage
import local from './local';
import { getLanguage } from '../lang'

const res = {
    // local
    local,
    // 异步加载的组件
    coms: [],
    // body 的 class
    bodyClass: [],
    // 语言
    lang: getLanguage(),
};

export default res;